<template>
	<div
		class="settings-view"
		:class="{ 'pointer-events-none': isCameraActive }"
	>
		<ModalWindow
			:heading="translate('ui.settings')"
			:isElevated="false"
			fullWidthContent
		>
			<template #content>
				<Tabs
					:key="redrawIterator"
					:tabs="settingsTabs"
					:selected-index="Number(paramTab)"
				>
					<template v-slot:tab1>
						<BasicSettingsView
							@languageChanged="onLanguageChanged"
						/>
					</template>
					<template v-slot:tab2>
						<InterfaceSettingsView />
					</template>
					<template v-slot:tab3>
						<AccountSettingsView />
					</template>
					<template v-slot:tab4>
						<SupportSettingsView />
					</template>
				</Tabs>
			</template>
		</ModalWindow>
	</div>
</template>

<script lang="ts" setup>
import ModalWindow from "@/components/ModalWindow.vue";
import Tabs from "@/components/Tabs.vue";
import useRuntimeStore from "@/store/useRuntimeStore";
import { translate } from "@/utils/translate";
import { storeToRefs } from "pinia";
import { computed, ref } from "vue";
import { useRoute } from "vue-router";
import AccountSettingsView from "./SubTabs/AccountSettingsView.vue";
import BasicSettingsView from "./SubTabs/BasicSettingsView.vue";
import InterfaceSettingsView from "./SubTabs/InterfaceSettingsView.vue";
import SupportSettingsView from "./SubTabs/SupportSettingsView.vue";

const { isCameraActive } = storeToRefs(useRuntimeStore());

const route = useRoute();
const settingsTabs = [
	{ name: "ui.basic" },
	{ name: "ui.interface" },
	{ name: "ui.account" },
	{ name: "ui.support" },
];

const paramTab = computed((): string | Array<string> => {
	return route.params.tab;
});

const redrawIterator = ref<number>(0);

const onLanguageChanged = (): void => {
	redrawIterator.value += 1;
};
</script>

<style lang="scss" scoped></style>
